import React from 'react'

const TermsOfUse = () => {
  return (
    <div>
      
    </div>
  )
}

export default TermsOfUse
